import api from './api';

export const clientsService = {
  // Get all clients
  getAll: async () => {
    const response = await api.get('/clients');
    return response.data;
  },

  // Get single client
  getById: async (id) => {
    const response = await api.get(`/clients/${id}`);
    return response.data;
  },

  // Create new client
  create: async (clientData) => {
    const response = await api.post('/clients', clientData);
    return response.data;
  },

  // Update client
  update: async (id, clientData) => {
    const response = await api.put(`/clients/${id}`, clientData);
    return response.data;
  },

  // Delete client
  delete: async (id) => {
    const response = await api.delete(`/clients/${id}`);
    return response.data;
  },

  // Get client quotes
  getClientQuotes: async (clientId) => {
    const response = await api.get(`/clients/${clientId}/quotes`);
    return response.data;
  },

  // Get client itineraries
  getClientItineraries: async (clientId) => {
    const response = await api.get(`/clients/${clientId}/itineraries`);
    return response.data;
  }
};
